import React, { Component } from 'react';
import classNames from 'classnames';

import { Info as InfoIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import { WalletColumnConstants } from '../../../config/constants';
import VirtualTransactionJsonDuck from '../../../ducks/VirtualTransactionJsonDuck';

const styles = (theme) => ({
  arrow: {
    position: 'absolute',
    left: `${WalletColumnConstants.transactionColumnWidth / 2}px`,
    top: `${WalletColumnConstants.transactionRowHeight / 2 - 4}px`,
    height: '8px',
    backgroundColor: WalletColumnConstants.arrowColor,
  },
  arrowHead: {
    position: 'absolute',
    top: '-6px',
    width: 0,
    height: 0,
    borderTop: `${WalletColumnConstants.arrowSize}px solid transparent`,
    borderBottom: `${WalletColumnConstants.arrowSize}px solid transparent`,
  },
  arrowHeadLeft: {
    borderRight: `${WalletColumnConstants.arrowSize}px solid ${WalletColumnConstants.arrowColor}`,
    left: `-${WalletColumnConstants.arrowSize}px`,
  },
  arrowHeadRight: {
    borderLeft: `${WalletColumnConstants.arrowSize}px solid ${WalletColumnConstants.arrowColor}`,
    right: `-${WalletColumnConstants.arrowSize}px`,
  },
  amount: {
    position: 'absolute',
    left: 0,
    top: '10px',
    width: '100%',
    textAlign: 'center',
    lineHeight: '24px',
  },
  clearingArrow: {
    backgroundColor: WalletColumnConstants.clearingColor,
  },
  clearingArrowHeadLeft: {
    borderRight: `${WalletColumnConstants.arrowSize}px solid ${WalletColumnConstants.clearingColor}`,
  },
  clearingArrowHeadRight: {
    borderLeft: `${WalletColumnConstants.arrowSize}px solid ${WalletColumnConstants.clearingColor}`,
  },
  amountText: {
    position: 'relative',
    zIndex: 1000,
  },
  jsonLink: {
    cursor: 'pointer',
  },
  infoIcon: {
    verticalAlign: 'top',
    cursor: 'pointer',
  },
});

class VirtualTransaction extends Component {
  componentWillMount() {
    const { virtualTransaction, displayColumn, classes } = this.props;
    const width =
      (virtualTransaction.targetWalletDisplayColumn - displayColumn) *
      (WalletColumnConstants.transactionColumnWidth +
        WalletColumnConstants.transactionColumnMargin);
    const isPointingRight =
      virtualTransaction.targetWalletDisplayColumn - displayColumn > 0;
    const isPointingLeft =
      virtualTransaction.targetWalletDisplayColumn - displayColumn < 0;
    const isClearing = virtualTransaction.type === 'Clearing';
    this.setState({
      width: Math.abs(width) - WalletColumnConstants.arrowSize,
      marginLeft: width < 0 ? width + WalletColumnConstants.arrowSize : 0,
      arrowClassName: classNames(
        classes.arrow,
        isClearing && classes.clearingArrow,
      ),
      arrowHeadClassName: classNames(
        classes.arrowHead,
        isPointingRight && classes.arrowHeadRight,
        isPointingLeft && classes.arrowHeadLeft,
        isPointingRight && isClearing && classes.clearingArrowHeadRight,
        isPointingLeft && isClearing && classes.clearingArrowHeadLeft,
      ),
    });
  }

  render() {
    const { classes, virtualTransaction } = this.props;
    return (
      <div
        className={this.state.arrowClassName}
        style={{
          marginLeft: `${this.state.marginLeft}px`,
          width: `${this.state.width}px`,
        }}
      >
        <div className={this.state.arrowHeadClassName}></div>
        <div className={classes.amount}>
          <span className={classes.amountText}>
            <span
              className={classes.jsonLink}
              onClick={this._showVirtualTransactionJson}
            >
              {virtualTransaction.amount.currency}{' '}
              {virtualTransaction.amount.amount}
            </span>{' '}
            <a
              href={
                'https://demowallet.trimplement.com/admin/virtual-transactions/' +
                virtualTransaction.id
              }
              target="_new"
            >
              <InfoIcon className={classes.infoIcon} />
            </a>
          </span>
        </div>
      </div>
    );
  }

  _showVirtualTransactionJson = () => {
    const { virtualTransaction } = this.props;
    this.props.showVirtualTransactionJsonDialog({ virtualTransaction });
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    showVirtualTransactionJsonDialog: ({ virtualTransaction }) => {
      return dispatch(
        VirtualTransactionJsonDuck.creators.showVirtualTransactionJsonDialog({
          virtualTransaction,
        }),
      );
    },
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(withStyles(styles)(VirtualTransaction));
